import React from 'react';
import { PricesAccordionTab, PricesTabType } from 'store/state/selectors/insights/prices';
import { SmallText, Text } from 'ds/components/typography';
import { ShowAt } from 'consts/breakpoints';
import { useLocale } from 'locale';
import { getTabTotalItemsCount } from '../../utils';
import { TabHeaderWrapper } from './styled';

interface TabHeaderProps {
  activeTab: PricesTabType;
  tab: PricesAccordionTab;
  isProjectPage?: boolean;
  currentBulletinId: string;
}

const TabHeader: React.FC<TabHeaderProps> = ({
  currentBulletinId,
  isProjectPage = false,
  activeTab,
  tab,
}) => {
  const { t } = useLocale();

  const text = isProjectPage
    ? t('widget.prices.accordionTabTitleProject', {
      type: tab.tabId,
      amount: getTabTotalItemsCount(tab, currentBulletinId),
    })
    : t('widget.prices.accordionTabTitle', {
      type: tab.tabId,
      amount: getTabTotalItemsCount(tab, currentBulletinId),
    });

  return (
    <TabHeaderWrapper
      data-auto={tab.tabId}
      style={{ minWidth: 'auto' }}
      key={tab.tabId}
      isActive={tab.tabId === activeTab}
    >
      <ShowAt from={2}>
        <Text>
          {text}
        </Text>
      </ShowAt>
      <ShowAt to={1}>
        <SmallText>
          {text}
        </SmallText>
      </ShowAt>
    </TabHeaderWrapper>
  );
};

export default TabHeader;
